module.exports = __webpack_public_path__ + "img/faceSwap.c345ce67.webp";